import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { MaintenanceSolicitationValidationSchema } from '@/features/maintenanceSolicitations/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateMaintenanceSolicitationProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCreateMaintenanceSolicitation = ({ onSuccess, onError }: UseCreateMaintenanceSolicitationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createMaintenanceSolicitation'],
    mutationFn: async (form: MaintenanceSolicitationValidationSchema) => {
      const solicitation = {
        photos_attachments_attributes: form.photos_attachments?.map((attachment) => ({
          blob_id: attachment.id,
        })),
        equipment_id: form.equipment_id?.value,
        kind: form.kind?.value,
        observations: form.observations,
        objectives_attributes: form.objectives?.map((objective) => ({
          system_id: objective.system_id.value,
          part_id: objective.part_id.value,
          action_id: objective.action_id.value,
        })),
      }

      return privateAxios.post('/maintenance/solicitations', solicitation)
    },
    onSuccess,
    onError,
  })
}
